"use strict";

require("core-js/modules/es.string.trim");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = exports.NSWPointV2API = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _api = _interopRequireDefault(require("../../api/api"));

var NSWPointV2API = /*#__PURE__*/function () {
  function NSWPointV2API() {
    var _this = this;

    this.currentRequestNo = 0;
    this.defaultApikey = "";
    this.pointNSWDomain = "https://point.digital.nsw.gov.au";

    this.getLatestSuggestions = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(value, apiKey, apiState, apiAddressType, apiDataSet) {
        var _yield$_this$getSugge, requestNo, suggestions;

        return _regenerator.default.wrap(function (_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getSuggestions(value, ++_this.currentRequestNo, apiKey, apiState, apiAddressType, apiDataSet);

              case 2:
                _yield$_this$getSugge = _context.sent;
                requestNo = _yield$_this$getSugge.requestNo;
                suggestions = _yield$_this$getSugge.suggestions;
                return _context.abrupt("return", {
                  suggestions: suggestions,
                  isLatest: requestNo === _this.currentRequestNo
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }();

    this.getSuggestions = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(value, requestNo, apiKey, apiState, apiAddressType, apiDataSet) {
        var url, suggestions;
        return _regenerator.default.wrap(function (_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                apiKey = _this.validatedApiKey(apiKey);
                url = _this.pointNSWDomain + "/v2/api/predictive1?address=" + value + "&maxNumberOfResults=5";

                if (apiState) {
                  url += "&stateTerritory=" + apiState;
                }

                if (apiAddressType) {
                  url += "&addressType=" + apiAddressType;
                }

                if (apiDataSet) {
                  url += "&dataset=" + apiDataSet;
                }

                _context2.next = 7;
                return _api.default.request(url, {
                  method: "GET",
                  headers: {
                    "x-api-key": apiKey
                  }
                });

              case 7:
                suggestions = _context2.sent;
                return _context2.abrupt("return", {
                  suggestions: suggestions instanceof Array ? suggestions : [],
                  requestNo: requestNo
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function () {
        return _ref2.apply(this, arguments);
      };
    }();

    this.getDetailsById = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(id, apiKey) {
        var body, addressDetails;
        return _regenerator.default.wrap(function (_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                apiKey = _this.validatedApiKey(apiKey);
                body = "{\"id\":\"" + id + "\"}";
                _context3.next = 4;
                return _api.default.request(_this.pointNSWDomain + "/v2/api/predictive2", {
                  method: "POST",
                  headers: {
                    "x-api-key": apiKey
                  },
                  body: body
                });

              case 4:
                addressDetails = _context3.sent;
                return _context3.abrupt("return", _this.convertAddress(addressDetails));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function () {
        return _ref3.apply(this, arguments);
      };
    }();

    this.convertAddress = function (address) {
      var _address$data = address.data,
          geo = _address$data.geo,
          addressDetails = _address$data.addressDetails,
          addressId = _address$data.addressId;
      var streetName = addressDetails.streetName,
          streetType = addressDetails.streetType,
          siteName = addressDetails.siteName,
          localityName = addressDetails.localityName,
          stateTerritory = addressDetails.stateTerritory,
          postcode = addressDetails.postcode,
          formattedAddress = addressDetails.formattedAddress; // check if we have a lat/long first, and then set the lat/long accordingly

      var latLong = geo && geo.geometry && geo.geometry.coordinates && 2 === geo.geometry.coordinates.length;
      var longitude = latLong ? geo.geometry.coordinates[0] : null;
      var latitude = latLong ? geo.geometry.coordinates[1] : null;
      return {
        unitNumber: _this.getIdentifier(addressDetails, !1),
        buildingNumber: _this.getIdentifier(addressDetails, !0),
        streetNumber: _this.getStreetNumber(addressDetails),
        streetName: streetName,
        streetType: streetType,
        propertyName: siteName,
        addressLine: null,
        suburb: localityName,
        state: stateTerritory,
        country: "AUSTRALIA",
        postcode: postcode,
        latitude: latitude,
        longitude: longitude,
        nswPointId: addressId,
        formattedAddress: formattedAddress,
        validated: !0
      };
    };

    this.getIdentifier = function (address, isBuilding) {
      var complexUnitType = address.complexUnitType,
          complexLevelType = address.complexLevelType,
          complexUnitIdentifier = address.complexUnitIdentifier,
          complexLevelNumber = address.complexLevelNumber;
      var identifier = "";

      if (null == complexUnitType && null == complexLevelType) {
        return null;
      }

      if (isBuilding && "BUILDING" !== complexUnitType) {
        return null;
      }

      if (!isBuilding && "BUILDING" === complexUnitType) {
        return null;
      }

      if (null != complexUnitType) {
        identifier += complexUnitType + " " + complexUnitIdentifier;
      }

      if (null != complexLevelType) {
        identifier += " " + complexLevelType + " " + complexLevelNumber;
      }

      return identifier.trim();
    };

    this.getStreetNumber = function (address) {
      var streetNumber1 = address.streetNumber1,
          streetNumber2 = address.streetNumber2;

      if (null == streetNumber1 && null == streetNumber2) {
        return null;
      }

      if (null != streetNumber1 && null != streetNumber2) {
        return streetNumber1 + "-" + streetNumber2;
      }

      return streetNumber1 || streetNumber2;
    };
  }

  var _proto = NSWPointV2API.prototype;

  _proto.validatedApiKey = function validatedApiKey(apiKey) {
    apiKey || console.warn("No api key provided for the nsw point, using default now.\n          Please request api key for your usage as the default api key will be removed soon.");
    apiKey = apiKey || this.defaultApikey;
    return apiKey;
  };

  return NSWPointV2API;
}();

exports.NSWPointV2API = NSWPointV2API;

var _default = new NSWPointV2API();

exports.default = _default;